import {useState, KeyboardEvent} from "react";
import {useSearchNavigation} from "./useSearchNavigation";

type Suggestion = {
    url: string;
};

type Params = {
    suggestions: Suggestion[];
    history: string[];
    onSearch: () => void;
    onClose: () => void;
    onBlur: () => void;
    onHistorySelect?: (value: string) => void;
    onSuggestionSelect?: (value: Suggestion) => void;
    onSuggestionSubmit?: (value: Suggestion) => void;
};

export const useSearchKeyboard = (
    {
        suggestions,
        history,
        onSearch,
        onClose,
        onBlur,
        onHistorySelect,
        onSuggestionSelect,
        onSuggestionSubmit,
    }: Params
) => {
    const [cursorHistory, setCursorHistory] = useState(-1);
    const [cursorSuggestions, setCursorSuggestions] = useState(-1);

    /**
     * Навигация по suggestions
     */
    const suggestionsNavigation = useSearchNavigation({
        items: suggestions,
        cursor: cursorSuggestions,
        setCursor: setCursorSuggestions,
        onSelect: onSuggestionSelect,
    });

    /**
     * Навигация по history
     */
    const historyNavigation = useSearchNavigation({
        items: history,
        cursor: cursorHistory,
        setCursor: setCursorHistory,
        onSelect: onHistorySelect,
    });

    /**
     * Обработка клавиатуры
     */
    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onBlur();
            onClose();

            const selectedSuggestion = suggestions[cursorSuggestions];

            if (selectedSuggestion) {
                onSuggestionSubmit(selectedSuggestion);
            } else {
                onSearch();
            }

            return;
        }

        if (suggestions.length > 0) {
            suggestionsNavigation.handleKeyDown(e);
            return;
        }

        if (history.length > 0) {
            historyNavigation.handleKeyDown(e);
        }
    };

    return {
        handleKeyDown,
        cursorHistory,
        cursorSuggestions,
    };
};
